import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';

import Hatch from './hatch';

const formatTime = (time, minFormat) => {
  const h = Math.floor(time / 3600);
  let m = Math.floor((time - h * 3600) / 60);
  const s = Math.floor(time - m * 60 - h * 3600);

  if (minFormat) {
    m = m + h * 60;
  }

  return minFormat ? `${m}${i18n.t('m')} ${s}${i18n.t('s')}` : `${h}${i18n.t('h')} ${m}${i18n.t('m')}`;
};

const Footer = ({ setup, change, active, C, isDay, selectedIndex, loaded }) => {
  const baseWidth = isPhone ? 112 : 143;
  const minFormat = isDay && selectedIndex !== null;
  return (
    <View
      style={{
        width: '100%',
        paddingHorizontal: scale(7),
        marginTop: scale(26),
        flexDirection: 'row',
      }}
    >
      {Boolean(active) && (
        <View style={{ width: scale(baseWidth) }}>
          <Text
            style={[
              {
                color: C('Status/Light/Active'),
              },
              font['Footnote'],
            ]}
          >
            {i18n.t('Active')}
          </Text>
          <Text
            style={[
              {
                color: C('Status/Light/Active'),
                fontVariant: ['tabular-nums'],
                opacity: loaded ? 1 : 0,
              },
              font['Subhead 1'],
            ]}
          >
            {formatTime(active, minFormat)}
          </Text>
        </View>
      )}
      <View style={{ width: scale(baseWidth) }}>
        <Text
          style={[
            {
              color: C('Status/Light/Change'),
            },
            font['Footnote'],
          ]}
        >
          {i18n.t('Change')}
        </Text>
        <Text
          style={[
            {
              color: C('Status/Light/Change'),
              fontVariant: ['tabular-nums'],
              opacity: loaded ? 1 : 0,
            },
            font['Subhead 1'],
          ]}
        >
          {formatTime(change, minFormat)}
        </Text>
      </View>
      <View style={{ width: scale(baseWidth) }}>
        <Text
          style={[
            {
              color: C('Status/Light/Setup'),
            },
            font['Footnote'],
          ]}
        >
          {i18n.t('Setup')}
        </Text>
        <Text
          style={[
            {
              color: C('Status/Light/Setup'),
              fontVariant: ['tabular-nums'],
              opacity: loaded ? 1 : 0,
            },
            font['Subhead 1'],
          ]}
        >
          {formatTime(setup, minFormat)}
        </Text>
      </View>
    </View>
  );
};

export default Footer;
